import {
  DownloadOutlined,
  FileExcelOutlined,
  MailOutlined,
  MessageOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Row,
} from "antd";
import React, { useState } from "react";
import { useAuthContext } from "../../common/providers/AuthProvider";
import { getPassengerData } from "../../helpers/PassegerData";
import ApiClient from "../../helpers/ApiClient";
import { OnlyFutureDateValidator } from "../../helpers/CustomValidators";
import { downloadTicketPdf } from "../../helpers/TicketUtils";
import Invoice from "./Model/UserInvoice";

const TicketSidebar = ({
  ticketData,
  ticketSearchParams,
  type,
  onCancelTicket,
}) => {
  const { user } = useAuthContext();
  const [smsForm] = Form.useForm();
  const [emailForm] = Form.useForm();

  const [userInvoiceVisible, setUserinvoiceVisible] = useState(false);
  const [limitCount, setLimitCount] = useState({
    smsCount: 0,
    emailCount: 0,
  });
  const [emailModalVisible, setEmailemailModalVisible] = useState(false);
  const [smsModalVisible, setSmsModalVisible] = useState(false);
  const [chgModel, setChgModel] = useState(false);
  const [cancelModel, setCancelModel] = useState(false);

  const toggleEmailModal = () => {
    emailForm.resetFields();
    if (!emailModalVisible) loadpassengerData("Email");
    setEmailemailModalVisible((prev) => !prev);
  };

  const toggleSmsModal = () => {
    smsForm.resetFields();
    if (!smsModalVisible) loadpassengerData("SMS");
    setSmsModalVisible((prev) => !prev);
  };

  const loadpassengerData = (type) => {
    let userID = 1;
    if (user) {
      if (user.UserID) {
        userID = user.UserID;
      }
    }
    if (userID != 1) {
      getPassengerData(userID).then((data) => {
        if (data.status) {
          if (type === "SMS") smsForm.setFieldsValue({ Mobile: data.Mobile });
          else emailForm.setFieldsValue({ Email: data.Email });
        }
      });
    }
  };

  const cancelTicketApiRequest = async (ref) => {
    const data = {
      ReferenceNumber: ref,
      ServiceType: 0,
      CancellationType: 0,
      UserID: 1,
      PNR: "string",
      AirlineCharges: 0,
      ServiceCharge: 0,
      RefundAmount: 0,
      FinalRefundAmount: 0,
      RefundStatus: 0,
      CancellationCharges: 0,
      RefundType: 0,
      Remarks: "string",
      CancelledRemarks: "string",
      CancellationRemarks: "string",
      APIProviderID: 0,
      Cancelledby: 0,
      CreatedBy: 0,
      ModifiedBy: 0,
    };

    const res = await ApiClient.post("admin/airCancelRequest", data);
  };

  const [amountpayble, setAmountPayble] = useState(0);
  const [amountpaybleA, setAmountPaybleA] = useState(0);
  const [amountpaybleB, setAmountPaybleB] = useState(0);
  const OnAChange = (v) => {
    setAmountPaybleA(v.target.value);
    updateAmountPaymble();
  };
  const OnBChange = (v) => {
    setAmountPaybleB(v.target.value);
    updateAmountPaymble();
  };
  const updateAmountPaymble = () => {
    setAmountPayble(parseInt(amountpaybleA) + parseInt(amountpaybleB));
  };
  const [ResheduleForm] = Form.useForm();
  const [CancelForm] = Form.useForm();
  const submitCancelETicket = (values) => {
    let sampleRequest = {
      ReferenceNumber: "string",
      ServiceType: 0,
      CancellationType: 0,
      UserID: 0,
      PNR: "string",
      AirlineCharges: 0,
      ServiceCharge: 0,
      RefundAmount: 0,
      FinalRefundAmount: 0,
      RefundStatus: 0,
      CancellationCharges: 0,
      RefundType: 0,
      Remarks: "string",
      CancelledRemarks: "string",
      CancellationRemarks: "string",
      APIProviderID: 0,
      CancelledBy: 0,
      CreatedBy: 0,
      ModifiedBy: 0,
    };

    const requestData = {
      ...sampleRequest,
      ...values,
      ReferenceNumber: ticketSearchParams.ref,
    };

    ApiClient.post("admin/airCancelRequest", requestData).then((res) => {
      if ((res.status = 200)) {
        message.success("Cancel Request Processed");
      } else {
        message.error("Something Went Wrong");
      }
    });

    setCancelModel(false);
  };
  const submitResheduleTicket = (values) => {
    let sampleRequest = {
      UserID: 0,
      PNR: "string",
      ReferenceNumber: "string",
      RescheduleType: 0,
      RescheduleTripType: 0,
      RescheduleSource: 0,
      RescheduleDestination: 0,
      RescheduleAirlineName: "string",
      RescheduleAirlineNumber: "string",
      RescheduleDepartureTime: "string",
      RescheduleArrivalTime: "string",
      RescheduleItineraryImage: "string",
      RescheduleRemarks: "string",
      RescheduleAirlineCharges: 0,
      RescheduleServiceCharge: 0,
      RescheduleRefundAmount: 0,
      RescheduleFinalRefundAmount: 0,
      RefundStatus: 0,
      RescheduleCharges: 0,
      RescheduleAdminRemarks: "string",
      CreatedBy: 0,
      ModifiedBy: 0,
    };
    const requestData = {
      ...sampleRequest,
      ...values,
      ReferenceNumber: ticketSearchParams.ref,
    };
    requestData.ResheduleDate = values.ResheduleDate.format("YYYY-MM-DD");

    ApiClient.post("admin/airRescheduleRequest", requestData).then((res) => {
      if ((res.status = 200)) {
        message.success("Reshedule Request Processed");
      } else {
        message.error("Something Went Wrong");
      }
    });

    setChgModel(false);
  };

  const sendETicket = (val) => {
    // console.log(val);
    ApiClient.post("notification/commonUtility", val).then((res) => {
      if (res.status === 200) {
        message.success(res.message);
        if (val.trigger === 1) {
          setEmailemailModalVisible(false);
        } else {
          setSmsModalVisible(false);
        }
      } else {
        message.error("Something Went Wrong");
      }
    });
  };
  const sendBusSmsETicket = (val) => {
    ApiClient.post("sms/BusTicket", val).then((res) => {
      if (res.status === 200) {
        message.success("Sms Sent Successfully");
        setSmsModalVisible(false);
      } else {
        message.error("Something Went Wrong");
      }
    });
  };

  const sendBusETicket = (val) => {
    // console.log(val,"sendemail");
    ApiClient.post("email/busticket", val).then((res) => {
      if (res.status === 200) {
        message.success("Email Sent Successfully");

        setEmailemailModalVisible(false);
      } else {
        message.error("Something Went Wrong");
      }
    });
  };

  const submitEmailForm = (val) => {
    // console.log(val, type, ticketData, "solu");
    if (limitCount.emailCount > 3) {
      message.error("Limit Exceeded");
      setEmailemailModalVisible(false);
      return;
    } else {
      setLimitCount((prev) => ({
        ...prev,
        emailCount: limitCount.emailCount + 1,
      }));
    }
    if (type === "Bus") {
      let formData = {
        to: val.Email,
        data: { ...ticketData },
      };
      sendBusETicket(formData);
    }

  };

  const sendSms = (val) => {
    if (limitCount.smsCount > 2) {
      message.error("Limit Exceeded");
      setSmsModalVisible(false);
      return;
    } else {
      setLimitCount((prev) => ({ ...prev, smsCount: limitCount.smsCount + 1 }));
      // console.log(limitCount);
    }
    if (type === "Bus") {
      let formData = {
        mobile: val.Mobile,
        data: { ...ticketData },
      };
      sendBusSmsETicket(formData);
    }
  };

  const handleCancel = (cancelTicketType) => {
    onCancelTicket(cancelTicketType);
  };
  const printTicket = () => {
    window.print();
  };

  return (
    <div className="actionable-buttons">
      <div className="ticket-options">
        <p onClick={downloadTicketPdf}>
          <DownloadOutlined /> Download E-Ticket
        </p>
      </div>

      <div className="ticket-options">
        <p onClick={() => printTicket()}>
          <PrinterOutlined /> Print E-Ticket
        </p>
      </div>

      <div className="ticket-options">
        <p onClick={() => toggleEmailModal()}>
          <MailOutlined /> Email E-Ticket
        </p>
      </div>

      {type === "Bus" ? (
        ticketData.cancellable ? (
          <div className="ticket-options">
            <p onClick={() => toggleSmsModal()}>
              <MessageOutlined /> Sms E-Ticket
            </p>
          </div>
        ) : null
      ) : ticketData.cancellable ? (
        <div className="ticket-options">
          <p onClick={() => toggleSmsModal()}>
            <MessageOutlined /> Sms E-Ticket
          </p>
        </div>
      ) : null}

      {type === "Bus" ? (
        ticketData.bookingStatus != "Cancelled" && ticketData.cancellable ? (
          <div className="ticket-options">
            <p onClick={() => handleCancel(type)}>
              <FileExcelOutlined /> Cancel E-Ticket
            </p>
          </div>
        ) : null
      ) : null}

      <Modal
        title="User Invoice"
        visible={userInvoiceVisible}
        onOk={() => setUserinvoiceVisible(false)}
        onCancel={() => setUserinvoiceVisible(false)}
        width={"75%"}
      >
        <Invoice />
      </Modal>

      <Modal
        title={[
          <div>
            <h6 style={{ marginBottom: "0px" }}>
              <strong>Email E-Ticket</strong>
            </h6>
          </div>,
        ]}
        className="promo-modal-header"
        visible={emailModalVisible}
        onOk={toggleEmailModal}
        onCancel={toggleEmailModal}
        footer={[
          <div>
            <Button key="close" onClick={toggleEmailModal}>
              Cancel
            </Button>

            <Button
              key="add"
              type="primary"
              htmlType="submit"
              onClick={emailForm.submit}
            >
              Send
            </Button>
          </div>,
        ]}
      >
        <Form form={emailForm} onFinish={submitEmailForm}>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Email"
                name="Email"
                rules={[
                  { required: true, message: "Required!" },
                  { type: "email", message: "Email is not a valid email" },
                ]}
              >
                <Input
                  autocomplete="newpassword" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        title={[
          <div>
            <h6 style={{ marginBottom: "0px" }}>
              <strong>SMS E-Ticket</strong>
            </h6>
          </div>,
        ]}
        className="promo-modal-header"
        visible={smsModalVisible}
        onOk={toggleSmsModal}
        onCancel={toggleSmsModal}
        footer={[
          <div>
            <Button key="close" onClick={toggleSmsModal}>
              Cancel
            </Button>

            <Button
              key="add"
              type="primary"
              htmlType="submit"
              onClick={smsForm.submit}
            >
              Submit
            </Button>
          </div>,
        ]}
      >
        <Form form={smsForm} onFinish={sendSms}>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Mobile No."
                name="Mobile"
                autoFocus
                rules={[
                  {
                    required: true,
                    message: "Mobile Number Required",
                  },
                  {
                    minLength: 10,
                    maxLength: 10,
                    pattern: "^[0-9]{10}$",
                    message: "Must be 10 digits",
                  },
                ]}
              >
                <Input
                  autocomplete="newpassword"
                  type="number"
                  maxLength="10"
                  className="number-specing"
                  placeholder="Enter Mobile number"
                  autoComplete="off"
                  autoFocus
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
export default TicketSidebar;
